import Action from 'redux/helpers/createAction'
const name = 'domainsData'

export const loadDomain = Action(name + '/GET_DOMAIN_DATA', (id, filters = {}) => ({
  id,
  filters
}))

export const loadDomainSuccess = Action(name + '/GET_DOMAIN_DATA_SUCCESS', (id, data) => ({
  id,
  data: data
}))

export const loadDomainFailure = Action(name + '/GET_DOMAIN_DATA_FAILURE', error => ({
  error
}))

export const flagGetDomainData = Action(name + '/FLAG_GET_DOMAIN_DATA')

export const loadDomainTags = Action(name + '/GET_DOMAIN_TAGS_DATA', id => ({
  id
}))

export const loadDomainTagsSuccess = Action(name + '/GET_DOMAIN_TAGS_DATA_SUCCESS', (id, data) => ({
  id,
  tags: data
}))

export const loadDomainTagsFailure = Action(name + '/GET_DOMAIN_TAGS_DATA_FAILURE', error => ({
  error
}))

export const loadDomainExtended = Action(name + '/GET_DOMAIN_DATA_EXTENDED', (id, filters) => ({
  id,
  filters
}))

export const addDomain = Action(name + '/ADD_DOMAIN_DATA', payload => ({
  payload
}))

export const addDomainSuccess = Action(name + '/ADD_DOMAIN_DATA_SUCCESS', data => ({
  data
}))

export const addDomainFailure = Action(name + '/ADD_DOMAIN_DATA_FAILURE', error => ({
  error
}))

export const updateDomain = Action(name + '/UPDATE_DOMAIN_DATA', (id, payload) => ({
  id,
  payload
}))

export const updateDomainSuccess = Action(name + '/UPDATE_DOMAIN_DATA_SUCCESS', () => ({}))

export const updateDomainFailure = Action(name + '/UPDATE_DOMAIN_DATA_FAILURE', error => ({
  error
}))

export const loadKeywords = Action(name + '/GET_DOMAIN_KEYWORDS_DATA', (id, filters = {}) => ({
  id,
  filters
}))

export const loadKeywordsSuccess = Action(
  name + '/GET_DOMAIN_KEYWORDS_DATA_SUCCESS',
  (id, keywords) => ({
    id,
    keywords
  })
)
export const loadKeywordsCompetitors = Action(
  name + '/GET_DOMAIN_KEYWORDS_COMPETITORS_DATA',
  (id, filters) => ({
    id,
    filters
  })
)

export const loadKeywordsResultsSuccess = Action(
  name + '/GET_DOMAIN_KEYWORDS_RESULTS_DATA_SUCCESS',
  (id, keywords) => ({
    id,
    keywords
  })
)
export const loadKeywordsChangesSuccess = Action(
  name + '/GET_DOMAIN_KEYWORDS_CHANGES_DATA_SUCCESS',
  (id, keywords) => ({
    id,
    keywords
  })
)
export const loadKeywordsCompetitorsResultsSuccess = Action(
  name + '/GET_DOMAIN_KEYWORDS_COMPETITORS_RESULTS_DATA_SUCCESS',
  (id, keywords) => ({
    id,
    keywords
  })
)
export const loadKeywordsCompetitorsChangesSuccess = Action(
  name + '/GET_DOMAIN_KEYWORDS_COMPETITORS_CHANGES_DATA_SUCCESS',
  (id, keywords) => ({
    id,
    keywords
  })
)

export const loadCompetitors = Action(name + '/GET_DOMAIN_COMPETITORS_DATA', (id, filters) => ({
  id,
  filters
}))

export const loadCompetitorsSuccess = Action(
  name + '/GET_DOMAIN_COMPETITORS_DATA_SUCCESS',
  (id, competitors) => ({
    id,
    competitors: competitors
  })
)

export const loadCompetitorsFailure = Action(
  name + '/GET_DOMAIN_COMPETITORS_DATA_FAILURE',
  error => ({
    error
  })
)

export const loadKeywordsFailure = Action(name + '/GET_DOMAIN_KEYWORDS_DATA_FAILURE', error => ({
  error
}))

export const loadDomainWithKeywords = Action(
  name + '/GET_DOMAIN_WITH_KEYWORDS_DATA_EXTENDED',
  (id, filters, loadDomain = true) => ({
    id,
    filters,
    loadDomain
  })
)

export const loadDomainWithCompetitor = Action(
  name + '/GET_DOMAIN_WITH_COMPETITOR_DATA_EXTENDED',
  (id, filters, loadDomain = true) => ({
    id,
    filters,
    loadDomain
  })
)

export const loadDomainWithPages = Action(
  name + '/GET_DOMAIN_WITH_PAGES_DATA_EXTENDED',
  (id, filters, loadDomain = true) => ({
    id,
    filters,
    loadDomain
  })
)
export const loadDomainWithSavings = Action(
  name + '/GET_DOMAIN_WITH_SAVINGS_DATA_EXTENDED',
  (id, filters, loadDomain = true) => ({
    id,
    filters,
    loadDomain
  })
)

export const loadDomainWithGrossing = Action(
  name + '/GET_DOMAIN_WITH_GROSSING_DATA_EXTENDED',
  (id, filters, loadDomain = true) => ({
    id,
    filters,
    loadDomain
  })
)

export const loadDomainWithDiscovery = Action(
  name + '/GET_DOMAIN_WITH_DISCOVERY_DATA_EXTENDED',
  (id, filters, loadDomain = true) => ({
    id,
    filters,
    loadDomain
  })
)

export const loadDomainWithNotification = Action(
  name + '/GET_DOMAIN_WITH_NOTIFICATION_DATA_EXTENDED',
  (id, filters, loadDomain = true) => ({
    id,
    filters,
    loadDomain
  })
)
export const getShareLink = Action(name + '/GET_SHARE_LINK', (id, payload) => ({
  id,
  payload
}))

export const getShareLinkSuccess = Action(name + '/GET_SHARE_LINK_SUCCESS', shareLink => ({
  shareLink
}))

export const getShareLinkFailure = Action(name + '/GET_SHARE_LINK_FAILURE', error => ({
  error
}))
